import { useApi } from '@/composables/useApi'

export default class IaqfazIntegrationClient {
  constructor() {
    this.api = useApi()
  }

  async getWorkflows(params = {}) {
    const { data } = await this.api.get('/iaqfaz-workflows', { params })
    return data.data || []
  }

  async createWorkflow(payload) {
    const { data } = await this.api.post('/iaqfaz-workflows', payload)
    return data
  }

  async updateWorkflow(id, payload) {
    const { data } = await this.api.put(`/iaqfaz-workflows/${id}`, payload)
    return data
  }

  async deleteWorkflow(id) {
    const { data } = await this.api.delete(`/iaqfaz-workflows/${id}`)
    return data
  }
}
